import { Flex } from "@redotech/redo-web/flex";
import Logo from "@redotech/redo-web/logo-wordmark.svg";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

import * as css from "./top-nav.module.css";

/** The dark bar above the nav rail, as in the admin app. */
export const TopNav = memo(function TopNav() {
  return (
    <Flex align="center" className={css.topNav} gap="md" w="full">
      <Logo className={css.logo} />
      <Text as="span" className={css.label} fontSize="sm" m="none">
        Partners
      </Text>
    </Flex>
  );
});
